import React from "react";
import { Ban, CheckCircle2, ScrollText, Trash2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatINR } from "@/lib/api";
import { STATUS_STYLE, grams, goldBalanceClass, inrBalanceClass } from "@/pages/admin/suppliers/supplierHelpers";

export const SuppliersTable = ({ suppliers, dualMap, staff, onOpenLedger, onEdit, onToggleStatus, onDelete }) => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <Table data-testid="suppliers-table">
        <TableHeader><TableRow className="bg-[#F4EBDD]">
          <TableHead>Supplier</TableHead><TableHead>Phone</TableHead>
          <TableHead className="text-right">Gold Owed</TableHead><TableHead className="text-right">Cash Owed</TableHead>
          <TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {suppliers.map((s) => {
            const dual = dualMap[s.id];
            return (
              <TableRow key={s.id} className="hover:bg-[#F7F0E6]">
                <TableCell>
                  <div className="font-medium">{s.name}</div>
                  <div className="text-xs text-muted-foreground">{s.company_name} · {s.supplier_no}</div>
                </TableCell>
                <TableCell className="font-mono text-sm">{s.phone || "-"}</TableCell>
                <TableCell className={`text-right font-mono ${goldBalanceClass(dual?.gold_balance_fine_g || 0)}`}>{grams(dual?.gold_balance_fine_g || 0)}</TableCell>
                <TableCell className={`text-right font-mono ${inrBalanceClass(s.outstanding)}`}>{formatINR(s.outstanding)}</TableCell>
                <TableCell><Badge className={STATUS_STYLE[s.status]}>{s.status}</Badge></TableCell>
                <TableCell className="text-right space-x-1">
                  <Button data-testid="supplier-ledger-button" size="sm" variant="ghost" className="gap-1" onClick={() => onOpenLedger(s)}><ScrollText className="h-3.5 w-3.5" /> Ledger</Button>
                  <Button size="sm" variant="ghost" onClick={() => onEdit(s)}>Edit</Button>
                  <Button size="sm" variant="ghost" className="gap-1" onClick={() => onToggleStatus(s)}>
                    {s.status === "active" ? <Ban className="h-3.5 w-3.5" /> : <CheckCircle2 className="h-3.5 w-3.5" />}
                  </Button>
                  {staff?.is_manager && (
                    <Button data-testid="supplier-delete-button" size="sm" variant="ghost" className="gap-1 text-destructive hover:text-destructive" onClick={() => onDelete(s)}><Trash2 className="h-3.5 w-3.5" /></Button>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
          {suppliers.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">No suppliers yet. Add your first supplier to get started.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </Card>
);
